import 'intersection-observer-polyfill/index.global'
import * as React from 'react'
import GlobalLayout from './src/containers/GlobalLayout'
import * as Sentry from '@sentry/gatsby'

Sentry.init({
  dsn: 'https://d2c59771fc21a4d91832c23d2df1dae4@o4509994295951360.ingest.de.sentry.io/4509994297393232',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['error'] })
  ],
  enableLogs: true,

  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.11,
  replaysOnErrorSampleRate: 1.0,

  // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/www\.lusini\.com/, /www\.lusini\.dev/, /dev\.lusini\.com/, /losini\.de/],

  // Debug mode for development
  // debug: process.env.NODE_ENV === 'development'
})

export function wrapPageElement({ element, props }) {
  return <GlobalLayout {...props}>{element}</GlobalLayout>
}

export function disableCorePrefetching() {
  return true
}

// export function onPrefetchPathname({ pathname, loadPage }) {
//   // if(pathname.includes('/pdp/')) return
//   // loadPage(pathname)
//   // console.log('Prefetching', pathname, loadPage)
// }
